import { Navigate, createBrowserRouter } from 'react-router-dom';
import paths, { rootPaths } from '@/routes/paths';
import { MainLayout } from '@/common/components/layout/main-layout';
import ErrorBoundary from '@/common/components/layout/errors/error-boundary/ErrorBoundary';

import { Dashboard } from '@/pages/dashboard';
import { SlaDashboard } from '@/pages/dashboard/sla-dashboard';
import { Clients } from '@/pages/clients';
import { ClientDetails } from '@/pages/client-details';
import { OrderIntakeForm } from '@/pages/orders/order-intake-form';
import { OrderOverview } from '@/pages/orders/order-overview';
import { Customers } from '@/pages/customers';
import { Subscriptions } from '@/pages/subscriptions';
import { RefreshTokenSettings } from '@/pages/refresh-token-settings';

const routes = [
  {
    element: <MainLayout />,
    errorElement: <ErrorBoundary />,
    children: [
      {
        path: '/',
        lazy: Dashboard
      },
      {
        path: paths.slaDashboard,
        lazy: SlaDashboard
      },
      {
        path: rootPaths.customersRoot,
        lazy: Customers
      },
      {
        path: rootPaths.subscriptionsRoot,
        lazy: Subscriptions
      },
      {
        path: rootPaths.clientsRoot,
        lazy: Clients
      },
      {
        path: paths.clientDetails(':clientId'),
        lazy: ClientDetails
      },
      {
        path: paths.clientActivities(':clientId'),
        lazy: ClientDetails
      },
      {
        path: rootPaths.ordersRoot,
        children: [
          {
            path: paths.orderIntakeForm,
            lazy: OrderIntakeForm
          },
          {
            path: paths.orderOverview,
            lazy: OrderOverview
          }
        ]
      },
      {
        path: rootPaths.settingsRoot,
        lazy: RefreshTokenSettings
      },
      {
        path: '*',
        element: <Navigate to={paths.error404} replace />
      }
    ]
  }
];

export const router = createBrowserRouter(routes, {
  basename: process.env.PUBLIC_URL
});

export default routes;
